import { isEmpty } from "@gemlightbox/core-kit";

export const validateForRequired = (value: any) => {
  if (isEmpty(value)) {
    return "This field is required.";
  }

  return "";
};
